const GiftIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={70} height={71} fill="none">
    <g filter="url(#a)">
      <mask
        id="b"
        width={49}
        height={20}
        x={5}
        y={12}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path
          fill="#fff"
          d="m53.517 12.031-17.176 13.18-5.273 4.12-.015.012-4.594.41-20.617 2.023 20.156-13.062 27.519-6.682Z"
        />
      </mask>
      <g mask="url(#b)">
        <path
          fill="#fff"
          d="m53.543 11.998-17.215 13.18-5.286 4.12-.015.012-4.591.425-20.608 2.092L26.02 18.753l27.522-6.755Z"
        />
      </g>
      <path
        fill="#DD3F49"
        fillRule="evenodd"
        d="m30.696 28.688 13.576 29.137-.02.002-17.703 2.192L8.908 34.094l17.45-4.33 4.319-1.071.019-.005Z"
        clipRule="evenodd"
      />
      <mask
        id="c"
        width={33}
        height={44}
        x={30}
        y={14}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path
          fill="#fff"
          d="m45.063 57.824 17.126-14.78L51.39 14.838 30.719 27.98l14.344 29.843Z"
        />
      </mask>
      <g mask="url(#c)">
        <path
          fill="#fff"
          d="M44.916 57.824 62.2 42.957l-10.662-28.12L30.705 28.09l14.21 29.734Z"
        />
      </g>
      <mask
        id="d"
        width={53}
        height={30}
        x={5}
        y={11}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path
          fill="#fff"
          d="m53.267 11.86 3.899 9.809-2.188 1.453L34.54 36.687l-.02.003-21.297 3.142-2.891.428-4.595-8.802 23.858-5.083L53.267 11.86Z"
        />
      </mask>
      <g mask="url(#d)">
        <path
          fill="#EDEDED"
          d="m53.335 11.848 3.849 9.742-2.195 1.456L34.5 36.637l-.02.004-21.301 3.224-2.892.438-4.55-8.737 23.87-5.167 23.73-14.551Z"
        />
      </g>
      <path
        fill="#D2D2D2"
        fillRule="evenodd"
        d="m29.694 26.537 14.58 31.288-17.732 2.206-13.595-19.963-2.897.5-4.312-8.404 23.956-5.627Z"
        clipRule="evenodd"
      />
      <path
        fill="#B4B4B4"
        fillRule="evenodd"
        d="m34.278 36.376 1.471 3.158-20.475 4.108-2.476-3.637 21.48-3.629Z"
        clipRule="evenodd"
      />
      <path
        fill="#CDCCC7"
        fillRule="evenodd"
        d="m34.279 36.376 20.824-13.812 1.278 3.528-20.63 13.441-1.472-3.157Z"
        clipRule="evenodd"
      />
      <path
        fill="#FF8E0D"
        fillRule="evenodd"
        d="M15.483 15.258s-1.41 3.212 1.706 5.061c2.27 1.348 10.099 2.03 10.099 2.03l-1.199.558s-7.473 1.898-12.236-.637c-4.762-2.535-3.61-8.84 1.63-7.011Z"
        clipRule="evenodd"
      />
      <path
        fill="#FFC685"
        fillRule="evenodd"
        d="M26.197 22.858s-15.883 1.95-14.2-5.715c1.445-6.575 15.398 5.157 15.398 5.157l2.506-1.168s-9.72-18.296-18.177-8.846c-5.355 5.983 2.405 15.408 14.473 10.572Z"
        clipRule="evenodd"
      />
      <path
        fill="#FF8E0D"
        fillRule="evenodd"
        d="M31.79 7.433s3.367.985 2.778 4.56c-.429 2.606-4.94 9.039-4.94 9.039l1.198-.559s6.259-4.502 7.382-9.779c1.122-5.277-4.446-8.45-6.417-3.261Z"
        clipRule="evenodd"
      />
      <path
        fill="#FFC685"
        fillRule="evenodd"
        d="M30.819 20.25S42.526 9.343 35.575 5.702c-5.964-3.124-5.956 15.106-5.956 15.106l-2.506 1.168s-7.757-19.21 4.92-19.608c8.024-.252 10.25 11.752-1.215 17.882ZM26.749 22.373 14.96 30.02l4.744 8.916 10.9 20.626 6.257-.784L22.145 29l7.11-7.794-2.506 1.167Z"
        clipRule="evenodd"
      />
      <path
        fill="#FFC685"
        fillRule="evenodd"
        d="m26.87 22.426 11.94-1.875 13.338 30.423 4.745-4.015-8.929-21.878-3.775-9.362-13.39 4.085-3.93 2.622Z"
        clipRule="evenodd"
      />
      <path
        fill="#FF8E0D"
        fillRule="evenodd"
        d="m26.423 37.667 1.69 3.4-6.59 1.303-1.87-3.527 6.77-1.176ZM43.167 30.486l5.508-3.66 1.385 3.386-5.456 3.557-1.437-3.283Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <filter
        id="a"
        width={76.102}
        height={78}
        x={-2.051}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={5} />
        <feGaussianBlur stdDeviation={2.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3661_39033"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_3661_39033"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
export { GiftIcon }
